// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

//biome-ignore lint/style/useImportType: this is usefulle
import * as React from "react";
import { ApplicationEnvironmentContextProvider } from "./ApplicationEnvironmentContextProvider";
import { jsx as _jsx } from "react/jsx-runtime";
export const ApplicationEnvironment = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(ApplicationEnvironmentContextProvider, {
    "data-sentry-element": "ApplicationEnvironmentContextProvider",
    "data-sentry-component": "ApplicationEnvironment",
    "data-sentry-source-file": "ApplicationEnvironment.tsx",
    children: children
  });
};